import React from 'react';
import sampleIcon from '../../assets/flask.svg'
import uploadIcon from '../../assets/upload-image-icon.svg'
import {
    InputGroup,
    Input,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Col,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import { connect } from "react-redux";
import {
    downloadSampleData,
    fetchLocationList,
    fetchBuilding,
    fetchFloors,
    saveSample,
} from '../../actions';
import { toast } from 'react-toastify';
import moment from 'moment';
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import './addSample.css';
import Draggable from "react-draggable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import CustomToolTip from '../SubComponents/CustomTooltip/customTooltip';
import { withTranslation } from 'react-i18next';

const initialState = {
    sample_id: "",
    organism: "",
    location: "",
    date_time: null,
    comments: "",
    typeofSamples: "",
    typeofAnalysis: "",
    fileName: "",
    pictureFile: "",
    batchNumber: "",
    barcode: "",
    referenceGenome: "",
}

let building = sessionStorage.getItem("building")
let buildingId = sessionStorage.getItem("buildingId")
let buildingName = sessionStorage.getItem("buildingName")
let floor = sessionStorage.getItem("floor")
let floorId = sessionStorage.getItem("floorId")
let floorName = sessionStorage.getItem("floorName")

let errorDetails = ""

class AddSample extends React.Component {
    constructor(props) {
        super(props)

        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.validateData = this.validateData.bind(this)
        this.ErrorDetails = this.ErrorDetails.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onChange = this.onChange.bind(this)

        building = sessionStorage.getItem("building")
        buildingId = sessionStorage.getItem("buildingId")
        buildingName = sessionStorage.getItem("buildingName")
        floor = sessionStorage.getItem("floor")
        floorId = sessionStorage.getItem("floorId")
        floorName = sessionStorage.getItem("floorName")

        let floorInitialState = {
            building: building ? building : localStorage.getItem("guest") ? "BldgA" : "",
            floor: floor ? floor : localStorage.getItem("guest") ? 20000 : "",
            floorId: floorId ? floorId : localStorage.getItem("guest") ? 20000 : "",
            buildingId: buildingId ? buildingId : localStorage.getItem("guest") ? 20000 : "",
            buildingName: buildingName ? buildingName : localStorage.getItem("guest") ? "Building A" : "",
            floorName: floorName ? floorName : localStorage.getItem("guest") ? "Floor A" : "",
        }
        this.state = {
            ...initialState,
            ...floorInitialState
        }
    }
    componentDidMount = () => {
        this.setState({
            date_time: this.nearestMinutes(15, moment())._d,
        })
    }
    onSelectBuilding = (event, flag = false) => {
        if (flag === false) {
            const { value, selectedOptions } = event.target
            sessionStorage.setItem("building", value)
            sessionStorage.setItem("buildingId", selectedOptions[0].id)
            sessionStorage.setItem("buildingName", selectedOptions[0].innerText)
            sessionStorage.setItem("floor", "")
        }
        this.setState({
            ...this.state,
            building: sessionStorage.getItem("building"),
            buildingId: sessionStorage.getItem("buildingId"),
            buildingName: sessionStorage.getItem("buildingName"),
            floor: "",
            location: "",
        }, async () => {
            await this.props.fetchFloors(this.state.buildingId)
            if (sessionStorage.getItem("floor"))
                await this.onSelectFloor("", true)
        })
    }

    onSelectFloor = (event, flag = false) => {
        if (flag === false) {
            const { value, selectedOptions } = event.target
            sessionStorage.setItem("floorName", selectedOptions[0].innerText)
            sessionStorage.setItem("floorId", selectedOptions[0].id)
            sessionStorage.setItem("floor", value)
        }
        this.setState({
            ...this.state,
            floor: sessionStorage.getItem("floor"),
            floorId: sessionStorage.getItem("floorId"),
            floorName: sessionStorage.getItem("floorName"),
            location: "",
        }, () => {
            this.props.fetchLocationList({
                floor__id: this.state.floorId,
                floor__building_id: this.state.buildingId
            })
        })
    };

    nearestMinutes = (interval, someMoment) => {
        const roundedMinutes = Math.round(someMoment.clone().minute() / interval) * interval;
        return someMoment.clone().minute(roundedMinutes).second(0);
    };

    onChange = date => {
        return this.setState({ date_time: date })
    };

    handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const newAnalysisTypes = [
            'Salmonella spp', 'Listeria monocytogenes', 'Listeria spp',
            'Contagem Total de Mesófilos', 'Bolores e Leveduras',
            'Estafilococos coagulase Positiva', 'Bacillus cereus',
            'Coliformes Totais', 'Escherichia coli', 'Enterobacterias'
        ];
        if (name === 'typeofAnalysis' && newAnalysisTypes.includes(value)) {
            this.setState({ ...this.state, [name]: value, organism: value });
        } else {
            this.setState({ ...this.state, [name]: value });
        }
    };

    saveData = () => {
        if (this.validateData(this.state)) {
            let organism = this.state.typeofAnalysis === "Microbiome" ? "" : this.state.organism ? this.state.organism[0].toUpperCase() + this.state.organism.substr(1, this.state.organism.length).toLowerCase() : ""
            let split_data = this.state.location.split(',')
            let location = split_data[0]
            let unit = ""
            if (split_data.length === 2) {
                unit = split_data[1]
            }
            this.props.saveSample({
                organism: organism,
                location: location,
                unit: unit,
                date_time: this.state.date_time,
                comments: this.state.comments,
                type_of_analysis: this.state.typeofAnalysis,
                type_of_samples: this.state.typeofSamples,
                picture: this.state.pictureFile,
                batch_no: this.state.batchNumber,
                barcode: this.state.barcode,
                reference_genome: this.state.typeofAnalysis === "SNP" ? this.state.referenceGenome : ""
            }).then(response => {
                if (response && response.status === 201) {
                    let message = "Sample data added successfully to the list"

                    if (appInsights) {
                        appInsights.trackEvent({ name: 'Sample Created', properties: { id: response.data.barcode } });
                        appInsights.trackTrace({ message: 'Sample Created', properties: { id: response.data.barcode }, severityLevel: SeverityLevel.Information })
                    }
                    toast.success(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                    this.setState(initialState)
                    this.setState({
                        date_time: this.nearestMinutes(15, moment())._d,
                    })
                    this.props.downloadSampleData()
                }
                else if (!navigator.onLine) {
                    let message = "Sample List added in offline mode!"
                    if (appInsights) {
                        appInsights.trackTrace({ message: message, properties: { id: this.state.barcode }, severityLevel: SeverityLevel.Information })
                    }
                    toast.warn(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
                else {
                    let message = "Sample List couldn't be added!"
                    if (appInsights) {
                        appInsights.trackTrace({ message: message, properties: { id: this.state.barcode }, severityLevel: SeverityLevel.Error })
                    }
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            })
                .catch((error) => {
                    let errors = (error.response && error.response.data) || ""
                    if (errors && errors.barcode) {
                        let message = "Sample with this EF Barcode already exists!"
                        if (appInsights) {
                            appInsights.trackTrace({ message: message, properties: { id: this.state.barcode, error: error }, severityLevel: SeverityLevel.Error })
                        }
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        })
                    }
                    else if (!navigator.onLine) {
                        let message = "Sample List added in offline mode!"
                        if (appInsights) {
                            appInsights.trackTrace({ message: message, properties: { id: this.state.barcode, error: error }, severityLevel: SeverityLevel.Information })
                        }
                        toast.warn(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                    else {
                        let message = "Sample couldn't be added!"
                        if (appInsights) {
                            appInsights.trackTrace({ message: message, properties: { id: this.state.barcode, error: error }, severityLevel: SeverityLevel.Error })
                        }
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        })
                    }
                })
        }
        else {
            this.ErrorDetails()
        }
    }

    ErrorDetails = () => {

        if (appInsights) {
            appInsights.trackTrace({ message: errorDetails, severityLevel: SeverityLevel.Verbose })
        }
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    resetData = () => {
        this.setState(prevState => ({
            ...initialState,
            toggle: prevState.toggle,
            filter_date_time: ""
        }), () => {
        })
    }

    validateData = (data) => {
        let isValidDate = moment(data.date_time).isValid()
        if (data.barcode.trim().length === 0 && isValidDate && data.location.length === 0 && data.organism.trim().length === 0 && data.referenceGenome.trim().length === 0) {
            errorDetails = "All *mandatory fields are required to save Sample data"
            return false
        }
        if (data.barcode.trim().length > 0 && isValidDate && data.location.length > 0 && ((data.organism.trim().length > 0 || data.typeofAnalysis === 'Microbiome' && data.organism.trim().length === 0)) && ((data.typeofAnalysis === "SNP" && data.referenceGenome.trim().length > 0) || (data.typeofAnalysis !== "SNP"))) {
            return true
        }
        else if (data.barcode.trim().length > 0 && isValidDate && data.location.length > 0 && data.organism.trim().length > 0 && data.typeofAnalysis === "SNP" && data.referenceGenome.trim().length === 0) {
            errorDetails = "Reference Genome is empty"
            return false
        }
        else if (data.barcode.trim().length > 0 && isValidDate && data.organism.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length === 0) {
            errorDetails = "Select the Location from the dropdown"
            return false
        }
        else if (isValidDate && data.organism.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.barcode.trim().length === 0) {
            errorDetails = "EF Barcode value is empty"
            return false
        }
        else if (data.barcode.trim().length > 0 && isValidDate && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.organism.trim().length === 0) {
            errorDetails = "Organism value is empty"
            return false
        }
        else if (data.barcode.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.organism.trim().length > 0 && !isValidDate) {
            errorDetails = "Date entered is not valid"
            return false
        }
        else {
            errorDetails = "All *mandatory fields are required to save Sample data"
            return false
        }

    }

    handleFileChange({ target: { files } }) {
        if (files.length !== 0) {
            this.setState({
                fileName: files[0].name,
                pictureFile: files[0]
            })
        }
    }

    getLocations = () => {
        let locations = this.props.locationList
        let arr = []
        if (this.state.building && this.state.floor) {
            if (locations) {
                for (let i = 0; i < locations.length; i++) {
                    if (locations[i].unit) {
                        arr.push(<option key={i} value={locations[i].location_id + ',' + locations[i].unit.id}>
                            {locations[i].room.room_name + ', ' + locations[i].unit.description}
                        </option>)
                    }
                    else {
                        arr.push(<option key={i} value={locations[i].location_id}>{locations[i].room.room_name}</option>)
                    }
                }
            }
        }
        return arr
    }

    render() {
        return (
            <Draggable handle=".edit-popup" bounds={{ top: -10, left: -50, right: 50, bottom: 300 }} >
                <Modal isOpen={this.props.addSampleOpen} toggle={this.props.toggleAddSampleModal} className="overlay-modal">
                    <ModalHeader toggle={this.props.toggleAddSampleModal} className="edit-popup hover-move">
                        <Row form>
                            <Col sm={12} md={3} lg={2}>
                                <div className='sample-left-align'><img src={sampleIcon} alt='' className='nav-icons' /> Add Sample</div>
                            </Col>
                        </Row>
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <div>
                                <div>
                                    <h5 className="samples-heading">Add Sample</h5>
                                    <Row form>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className={this.state.building ? "overlay-inputs overlay-selected" : "overlay-inputs overlay-select"} type="select" name="building" id="Building" value={this.state.building} onChange={this.onSelectBuilding}>                                            <option value="" default className='overlay-default-option' disabled>{this.props.t('samples.building')}</option>
                                                {this.props.buildingList.map((building, key) => {
                                                    return <option id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className={this.state.floor ? "overlay-inputs overlay-selected" : "overlay-inputs overlay-select"} type="select" name="floor" id="Floor" value={this.state.floor} onChange={this.onSelectFloor}>
                                                <option value="" default className='overlay-default-option' disabled>{this.props.t('samples.floor')}</option>
                                                {this.props.floorsList.map((floor, key) => {
                                                    return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className={this.state.location ? "overlay-inputs overlay-selected" : "overlay-inputs overlay-select"} type="select" name="location" id="Location" value={this.state.location} onChange={this.handleChange}>
                                                <option value="" default disabled>{this.props.t('samples.location')}</option>
                                                {this.getLocations()}
                                            </Input>
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className="overlay-inputs" type="text" name="location" id="Location" value={this.state.location} onChange={this.handleChange} placeholder={this.props.t('samples.locationId')} />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <div>
                                                <DatePicker id="" onChange={this.onChange} selected={this.state.date_time ? this.state.date_time : this.nearestMinutes(15, moment())._d}
                                                    filterDate={(date) => {
                                                        return moment() > date;
                                                    }}
                                                    placeholderText={this.props.t('samples.date')}
                                                    maxDate={new Date()}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    wrapperClassName="datepicker-wrapper"
                                                    popperClassName="datepicker-popper"
                                                    showTimeSelect
                                                    timeFormat="HH:mm"
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    className="overlay-inputs form-control"
                                                    dateFormat="MMMM d, yyyy HH:mm"
                                                    dateFormatCalendar=" " />
                                            </div>
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <InputGroup>
                                                <Input className="overlay-inputs barocde-input" type="text" name="barcode" id="EFBarcode" value={this.state.barcode} onChange={this.handleChange} placeholder={this.props.t('samples.efBarcode')}/>
                                                <FontAwesomeIcon icon={faInfoCircle} id="EFBarcodeicon" className='barcode-tooltip-icon demo-icon' />
                                                <CustomToolTip placement="top" target="EFBarcodeicon" hide={false} text="This is the barcode generated by Eurofins for your order" />
                                            </InputGroup>
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className="overlay-inputs" type="text" name="typeofSamples" id="SampleType" value={this.state.typeofSamples} onChange={this.handleChange} placeholder={this.props.t('samples.typeOfSample')} />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className={this.state.typeofAnalysis ? "overlay-inputs overlay-selected" : "overlay-inputs overlay-select"} type="select" name="typeofAnalysis" id="AnalysisType" value={this.state.typeofAnalysis} onChange={this.handleChange} >
                                                <option value="" default className='overlay-default-option'>{this.props.t('samples.typeOfAnalysis')}</option>
                                                <optgroup label="Molecular">
                                                    <option className="dashboard-options" value="SNP">SNP</option>
                                                    <option className="dashboard-options" value="cgMLST">cgMLST</option>
                                                    <option className="dashboard-options" value="Microbiome">Microbiome</option>
                                                    <option className="dashboard-options" value="Other">Other</option>
                                                </optgroup>
                                                <optgroup label="Monitoramento Ambiental - Qualitativo">
                                                    <option className="dashboard-options" value="Salmonella spp">Salmonella spp</option>
                                                    <option className="dashboard-options" value="Listeria monocytogenes">Listeria monocytogenes</option>
                                                    <option className="dashboard-options" value="Listeria spp">Listeria spp</option>
                                                    <option className="dashboard-options" value="Estafilococos coagulase Positiva">Estafilococos coagulase Positiva</option>
                                                    <option className="dashboard-options" value="Escherichia coli">Escherichia coli</option>
                                                    <option className="dashboard-options" value="Enterobacterias">Enterobacterias</option>
                                                </optgroup>
                                                <optgroup label="Monitoramento Ambiental - Quantitativo">
                                                    <option className="dashboard-options" value="Contagem Total de Mesófilos">Contagem Total de Mesófilos</option>
                                                    <option className="dashboard-options" value="Bolores e Leveduras">Bolores e Leveduras</option>
                                                    <option className="dashboard-options" value="Bacillus cereus">Bacillus cereus</option>
                                                    <option className="dashboard-options" value="Coliformes Totais">Coliformes Totais</option>
                                                </optgroup>
                                            </Input>
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input disabled={this.state.typeofAnalysis === "Microbiome"} className="overlay-inputs" type="text" name="organism" id="Organism" value={this.state.typeofAnalysis != 'Microbiome' ? this.state.organism : ""} onChange={this.handleChange} placeholder={this.props.t('samples.organism')} />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input disabled={this.state.typeofAnalysis !== "SNP"} className="overlay-inputs" type="text" name="referenceGenome" id="referenceGenome" value={this.state.typeofAnalysis === "SNP" ? this.state.referenceGenome : ""} onChange={this.handleChange} placeholder={this.props.t('samples.referenceGenome')} />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className="overlay-inputs" type="text" name="batchNumber" id="BatchNo" value={this.state.batchNumber} onChange={this.handleChange} placeholder={this.props.t('samples.batchNumber')} />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <Input className="overlay-inputs" type="text" name="comments" value={this.state.comments} onChange={this.handleChange} placeholder={this.props.t('samples.comments')} />
                                        </Col>
                                    </Row>
                                    <Row form className="add-sample-end">
                                        <Col sm={4} md={3} lg={2}>
                                            <label for="overlay-image-upload" className='overlay-upload-label'>
                                                <img src={uploadIcon} id="image-upload-label" alt="" />
                                                <span className='upload-image' title={this.state.fileName || this.props.t('samples.uploadImage')}>{(this.state.fileName.length > 25 ? this.state.fileName.slice(0, 20) + '...' : this.state.fileName) || this.props.t('samples.uploadImage')}</span>
                                            </label>
                                            <Input
                                                type="file"
                                                id="overlay-image-upload"
                                                className="overlay-upload-file"
                                                accept=".png,.jpg, .jpeg"
                                                onChange={(e) => this.handleFileChange(e)}
                                                data-title={this.state.fileName || this.props.t('samples.uploadImage')}
                                            />
                                        </Col>
                                        <Col sm={4} md={3} lg={2} className="overlay-flex">
                                            <Button className="button-size overlay-cancel-button" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                            <Button className="button-size overlay-save-button" type="submit" onClick={this.saveData}>Save</Button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </Draggable>
        )
    }
}

const mapStateToProps = state => {
    return {
        sampleList: state.sample_data.sampleList,
        locationList: state.sample_data.locationList,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        downloadSampleData,
        fetchLocationList,
        saveSample,
        fetchBuilding,
        fetchFloors,
    }
)(withTranslation()(AddSample)), 'Add Sample', 'AddSample');